import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';

const BreadcrumbsLink = styled.a.attrs(() => {
  const classNamesToAdd = [
    'font-bold',
    'hover:text-basic-600',
    'transition-color',
    'ease-out',
    'duration-150',
    'focus:outline-none',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

// eslint-disable-next-line import/prefer-default-export
export { BreadcrumbsLink };
